import { Snackbar } from '@mui/material';
import Slide, { SlideProps } from '@mui/material/Slide';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import React from 'react';
import { useToast } from '../ToasterContext';

function SlideTransition(props: SlideProps) {
    return <Slide {...props} direction="down" />;
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ToastMessage: React.FC = () => {
    const toast = useToast();
    return (
        <Snackbar
            open={toast?.snackbarOpen}
            autoHideDuration={5000}
            onClose={toast?.onToggleSnackbar}
            TransitionComponent={SlideTransition}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <Alert
                onClose={toast?.onToggleSnackbar}
                severity={toast?.success ? 'success' : 'error'}
                sx={{ width: '100%' }}
            >
                {toast?.message}
            </Alert>
        </Snackbar>
    );
};

export default ToastMessage;
